// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2j0TO","skip":"styles_skip__1MNDq"};